module.exports = __webpack_public_path__ + "img/1696322329263-WhatsApp Image 2023-10-02 at 12.09.37 1.jpeg.fbacca4f.webp";